import { PlanTab } from '../../../../../components/verification/SubscriptionStep';
import { SubscriptionTerm } from '../../../../../services/exports/Constants';

export default {
  sections: {
    term: {
      description: 'Facturé mensuellement. Annuel est un engagement, pas une fréquence de facturation.',
      options: {
        [SubscriptionTerm.Monthly]: 'Engagement mensuel',
        [SubscriptionTerm.Annual]: 'Engagement annuel',
      },
    },
    plans: {
      tabs: {
        [PlanTab.actual]: {
          name: 'Modèle tarifaire',
          title: 'Tarification basée sur la performance',
        },
        [PlanTab.legacy]: {
          name: 'Ancien',
          title: 'Offres',
        },
      },
    },
    add_ons: {
      title: 'Devenez Pro avec nos modules complémentaires pour votre offre Essentielle',
      description: 'Attirez de nouveaux clients et fidélisez-les avec ces solutions logicielles.',
    },
  },
  labels: {
    recommended: 'Recommandé',
    basket: 'Panier : <strong>{{amount}}</strong> par mois',
  },
  buttons: {
    review_and_subscribe: "Vérifier et s'abonner",
    cancel: 'Annuler',
    basket: 'Retour au panier',
    subscribe: "S'abonner",
    update_subscription: "Mettre à jour l'abonnement",
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    failed_to_save_contract: "Échec de l'enregistrement du contrat de service",
    failed_to_create_subscription: "Échec de la création de l'abonnement",
    subscription_created: "L'abonnement a été créé avec succès",
    subscription_updated: "L'abonnement a été mis à jour avec succès",
  },
};
